import { render } from "./ContentFactory.vue?vue&type=template&id=396da99d&scoped=true"
import script from "./ContentFactory.vue?vue&type=script&lang=js"
export * from "./ContentFactory.vue?vue&type=script&lang=js"

import "./ContentFactory.vue?vue&type=style&index=0&id=396da99d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396da99d"]])

export default __exports__